/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

//TODO rename to iriroCustomPattern
@Directive({
  selector: '[customPattern], [iriro-customPattern]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomPatternValidator,
      multi: true,
    }
  ],
})
export class CustomPatternValidator implements Validator {
  @Input() fieldName = '';
  @Input('customPattern') regexPatternExp: RegExp | undefined = undefined;

  validate(control: AbstractControl): { [key: string]: any } | null {
    const funcProperties = {
      field: this.fieldName,
      regexPatternExp: this.regexPatternExp,
    };
    return _customPatternValidation.bind(funcProperties)(control);
  }
}

export const customPatternValidation = (
  fieldName = '',
  regexPatternExp: RegExp
): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
    regexPatternExp: regexPatternExp,
  };

  return _customPatternValidation.bind(funcProperties);
};

function _customPatternValidation(this: any, control: AbstractControl): {
  [key: string]: any;
} | null {
  let errors: ErrorModel | null = null;

  if (
    control.value !== null &&
    control.value !== undefined &&
    control.value !== ''
  ) {
    if (!this.regexPatternExp.test(control.value)) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: 'customPattern' + this.field,
      };
    }
  }

  return errors ? errors : null;
}
